import type { FileCategoryNode } from "@/lib/files/server";

/**
 * Total available files of a category **including every descendant**.
 * Counts are keyed per category slug and hold only that category's own files,
 * while files usually live in leaf categories — so a root badge must sum the
 * whole subtree, not just its direct children.
 */
export function countAvailableInSubtree(
  node: FileCategoryNode,
  counts: Record<string, number>,
): number {
  let total = counts[node.slug] ?? 0;
  for (const child of node.children ?? []) {
    total += countAvailableInSubtree(child, counts);
  }
  return total;
}
